import { map, Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SavedFilter } from '@core/models';

@Injectable({ providedIn: 'root' })
export class SavedFilterService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  update(savedFilter: Partial<SavedFilter>): Observable<SavedFilter> {
    return this.httpClient
      .put<any>(`saved_filters/${savedFilter.id}`, { saved_filter: savedFilter })
      .pipe(map(({ saved_filter }) => saved_filter));
  }
}
